import { userSessionTypes, platformNames } from '.';
import {
  NEED_HELP,
  NYKAA_CSR,
  MY_ORDERS,
  MY_WALLET,
  MY_PROFILE,
  MY_WISHLIST,
  HELP_CENTER,
  GIFT_CARDS,
  AUTHENTICITY,
  NYKAA_PRIVE,
  // NYKAA_SUBSCRIPTION,
  RESPONSIBLE_DISCLOSURE,
  VIDEO_CONSULTATION,
  SUSTAINABILITY,
} from './strings';
import { HELP_CENTER_URLS_POWERED_BY_KAPTURE, MY_ORDERS_URLS } from './urls';
import { MenuItemsMap } from 'types/Header';

const { beauty: BEAUTY_HELP_CENTER, men: MEN_HELP_CENTER } =
  HELP_CENTER_URLS_POWERED_BY_KAPTURE;
const { beauty: BEAUTY_MY_ORDERS, men: MEN_MY_ORDERS } = MY_ORDERS_URLS;
export const menuItems: MenuItemsMap = {
  [platformNames.NYKAA]: {
    [userSessionTypes.GUEST]: [
      {
        link: BEAUTY_HELP_CENTER,
        displayText: NEED_HELP,
      },
      {
        link: '/authenticity-nykaa-guarantee/lp?intcmp=hp,header,1,authenticity',
        displayText: AUTHENTICITY,
      },
      {
        link: '/nykaa-csr/lp',
        displayText: NYKAA_CSR,
      },
      {
        link: '/sustainability/lp',
        displayText: SUSTAINABILITY,
      },
      {
        link: '/responsible-disclosure/lp',
        displayText: RESPONSIBLE_DISCLOSURE,
      },
    ],
    [userSessionTypes.LOGGED_IN]: [
      {
        link: BEAUTY_MY_ORDERS,
        displayText: MY_ORDERS,
      },
      {
        link: '/prive',
        displayText: NYKAA_PRIVE,
      },
      {
        link: '/semiClosedWallet?ptype=nykaaWallet',
        displayText: MY_WALLET,
      },
      // {
      //   link: '/subscription',
      //   displayText: NYKAA_SUBSCRIPTION,
      // },
      {
        link: '/myProfile',
        displayText: MY_PROFILE,
      },
      {
        link: '/wishlist/',
        displayText: MY_WISHLIST,
      },
      // {
      //   link: '/sales/order/history/v2?ptype=myOrder',
      //   displayText: 'My Product Reviews',
      // },
      {
        link: '/authenticity-nykaa-guarantee/lp?intcmp=hp,header,1,authenticity',
        displayText: AUTHENTICITY,
      },
      {
        link: '/video-consultation',
        displayText: VIDEO_CONSULTATION,
        tag: 'NEW',
      },
      {
        link: BEAUTY_HELP_CENTER,
        displayText: HELP_CENTER,
      },
      {
        link: '/nykaa-csr/lp',
        displayText: NYKAA_CSR,
      },
      {
        link: '/sustainability/lp',
        displayText: SUSTAINABILITY,
      },
      {
        link: '/responsible-disclosure/lp',
        displayText: RESPONSIBLE_DISCLOSURE,
      },
    ],
  },
  [platformNames.MEN]: {
    [userSessionTypes.GUEST]: [
      {
        link: MEN_HELP_CENTER,
        displayText: NEED_HELP,
      },
      {
        link: '/giftcard/list',
        displayText: GIFT_CARDS,
      },
      {
        link: '/responsible-disclosure/lp',
        displayText: RESPONSIBLE_DISCLOSURE,
      },
    ],
    [userSessionTypes.LOGGED_IN]: [
      {
        link: MEN_MY_ORDERS,
        displayText: MY_ORDERS,
      },
      {
        link: '/myProfile',
        displayText: MY_PROFILE,
      },
      {
        link: '/semiClosedWallet?ptype=nykaaWallet',
        displayText: MY_WALLET,
      },
      {
        link: '/wishlist/',
        displayText: MY_WISHLIST,
      },
      // {
      //   link: '/sales/order/history/v2?ptype=myOrder',
      //   displayText: 'My Product Reviews',
      // },
      {
        link: MEN_HELP_CENTER,
        displayText: HELP_CENTER,
      },
      {
        link: '/responsible-disclosure/lp',
        displayText: RESPONSIBLE_DISCLOSURE,
      },
    ],
  },
};

export const TOP_INAPP_CLICKED = 'top_inapp_clicked';
